import React from "react";

function WaveBackdrop(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            clipRule="evenodd"
            viewBox="0 0 2880 1774"
            width="100%"
            style={{ position: 'absolute', zIndex: '-1', top: '30px'}}

        >
            <filter id="shadow">
                <feDropShadow 
                    dx="12" 
                    dy="-12" 
                    stdDeviation="30" 
                    flood-color="#1b257b" 
                    flood-opacity="0.08"
                    />
            </filter>
            {/* <path
                fill={"url(#backblack)"}
                d="M2880 5.681H0l2.313 856.934H2880V5.681z"
                transform="matrix(1 0 0 .83803 0 -4.76)"
            ></path>
            <defs>
                <linearGradient id="backblack" x1="0" x2="0.5" y1="0.1" y2="0.85" >
                    <stop offset="0" stopColor="#525252" stopOpacity="100%"></stop>
                    <stop offset="1" stopColor="#050608" stopOpacity="100%"></stop>
                </linearGradient>
            </defs>  */}

            <path
                fill={"url(#wavebottom)"}
                d="M6450.26 803.324V410.508l2856.35 994.112v303.68c-21.69 7.27-118.67 56.87-231.74 63.9-145.38 9.04-311.09-25.3-311.09-25.3-295.88-59.69-518.43-237.56-695.29-319.34-190.99-88.32-587.84-24.11-760.71-49.7-379.16-56.14-465.16-277.33-857.52-574.536z"
                transform="matrix(1.00828 0 0 1 -6503.69 0)"
            ></path>
            <defs>
                <linearGradient id="wavebottom" x1="0.1" x2="1.03" y1="0.35" y2="0.9" >
                    <stop offset="0" stopColor="#F3FBFF" stopOpacity="100%"></stop>
                    <stop offset="1" stopColor="#E2F4FF" stopOpacity="100%"></stop>
                </linearGradient>
            </defs>

            <path
                fill="url(#wave1)"
                d="M6450.26 84.406c331.77 89.723 434.99 292.922 825.9 292.623l2.59-.005c37.1-.112 76.81-2.053 119.54-6.093 342.63-32.389 584.47-190.004 978.77-136.338 186.84 26.68 418 166.55 617.12 263.541 175.45 92.249 248.71 93.387 312.43 40.018V738.47L6450.26 551.473V84.406z"
                transform="matrix(1.00828 0 0 1 -6503.69 0)"
                filter="url(#shadow)"
            ></path>
            <defs>
                <linearGradient id="wave1" x1="0" x2="0.75" y1="0.1" y2="0.5" >
                    <stop offset="0" stopColor="#BED4F2" stopOpacity="100%"></stop>
                    <stop offset="1" stopColor="#2465C1" stopOpacity="100%"></stop>
                </linearGradient>
            </defs>

            <path
                fill="url(#wave2)"
                d="M6450.26 201.638c286.24 104.151 500.88 318.33 993.97 294.034 207.73-10.235 569.73-232.218 964.03-178.552 186.84 26.68 386.8 128.434 585.92 225.425 177.26 93.198 241.24 111.896 312.43 65.061v736.264L6450.26 558.651V201.638z"
                transform="matrix(1.00828 0 0 1 -6503.69 0)"
                filter="url(#shadow)"
            ></path>
            <defs>
                <linearGradient id="wave2" x1="0" x2="0.95" y1="0" y2="0.5" >
                    <stop offset="0" stopColor="#BDD4FE" stopOpacity="100%"></stop>
                    <stop offset="1" stopColor="#225EDD" stopOpacity="100%"></stop>
                </linearGradient>
            </defs>

            <path
                fill="url(#wave3)"
                d="M6450.26 237.674c466.48 322.411 773.84 387.565 1019.46 341.408 283.33-53.242 546.77-160.763 939.32-95.506 238.36 39.625 465.12 260.991 634.62 319.887 115.16 40.011 199.21 46.646 262.95 39.683V1383.8L6450.26 557.004v-319.33z"
                transform="matrix(1.00828 0 0 1 -6503.69 0)"
                filter="url(#shadow)"
            ></path>
            <defs>
                <linearGradient id="wave3" x1="0" x2="0.95" y1="0.15" y2="0.7" >
                    <stop offset="0" stopColor="#BDD6FF" stopOpacity="100%"></stop>
                    <stop offset="1" stopColor="#1260DE" stopOpacity="100%"></stop>
                </linearGradient>
            </defs>


            <path
                fill="url(#wave4)"
                d="M6450.26 315.33c192.28 137.475 515.79 411.379 1022.49 419.93 288.24 4.864 501.89-147.434 894.44-82.177 185.98 32.172 357.59 241.374 553.77 344.188 129.08 72.799 285.26 80.969 385.65 82.629v454.13c-577.01 203.03-778.11-164.97-1051.16-291.23-191-88.32-504.78-21.55-828.44-6.72-446.33 20.44-527.52-198.07-976.75-519.582V315.33z"
                transform="matrix(1.00828 0 0 1 -6503.69 0)"
                filter="url(#shadow)"
            ></path>
            <defs>
                <linearGradient id="wave4" x1="0.07" x2="0.83" y1="0.1" y2="0.83" >
                    <stop offset="0" stopColor="#CAE1FF" stopOpacity="100%"></stop>
                    <stop offset="1" stopColor="#2673DC" stopOpacity="100%"></stop>
                </linearGradient>
            </defs>
            
        </svg>
    );
}

export default WaveBackdrop;
